import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "@/components/ui/cn";

const VTabs = TabsPrimitive.Root;

const VTabsList = forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex items-center justify-start gap-5 border-b border-border text-muted-foreground",
      className,
    )}
    {...props}
  />
));
VTabsList.displayName = "VTabsList";

const VTabsTrigger = forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "-mb-px inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-t-sm border-b-2 border-transparent px-1 pb-2.5 pt-1 text-sm font-medium transition-colors",
      "hover:text-foreground",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "disabled:pointer-events-none disabled:opacity-50",
      "data-[state=active]:border-primary-600 data-[state=active]:text-primary-700",
      className,
    )}
    {...props}
  />
));
VTabsTrigger.displayName = "VTabsTrigger";

const VTabsContent = forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      className,
    )}
    {...props}
  />
));
VTabsContent.displayName = "VTabsContent";

export { VTabs, VTabsList, VTabsTrigger, VTabsContent };
